"use client";

import Link, { type LinkProps } from "next/link";
import type { AnchorHTMLAttributes, ReactNode } from "react";
import type { AnalyticsEventName } from "@/lib/analytics/events";
import { trackEvent } from "@/lib/analytics/track";

export default function TrackedLink({
  eventName,
  eventProps,
  channel,
  onClick,
  children,
  ...props
}: LinkProps & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> & {
  children: ReactNode;
  eventName: AnalyticsEventName;
  eventProps?: Record<string, string | number | boolean | null | undefined>;
  channel?: string | null;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}) {
  return (
    <Link
      {...props}
      onClick={(e) => {
        trackEvent(eventName, eventProps, { channel: channel ?? undefined });
        onClick?.(e);
      }}
    >
      {children}
    </Link>
  );
}
